import { render } from "./Results8.vue?vue&type=template&id=dad99244&scoped=true"
import script from "./Results8.vue?vue&type=script&lang=js"
export * from "./Results8.vue?vue&type=script&lang=js"

import "./Results8.vue?vue&type=style&index=0&id=dad99244&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dad99244"]])

export default __exports__